import "rsuite/dist/rsuite.min.css";
import "./index.css";

import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import router from "./router/router";
import initSentry from "./sentry";

initSentry();
// Dynamically create #modals-root
const modalsRoot = document.createElement("div");
modalsRoot.id = "modals-root";
document.body.appendChild(modalsRoot);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(
  <RouterProvider router={router} />,
);
